module.exports = __webpack_public_path__ + "img/6.3378d880.jpeg";